import { render, staticRenderFns } from "./ShortFIO.vue?vue&type=template&id=6a227893&scoped=true&"
import script from "./ShortFIO.vue?vue&type=script&lang=js&"
export * from "./ShortFIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a227893",
  null
  
)

export default component.exports